import { useQueryClient } from "@tanstack/react-query";

import type { ProfileResponse } from "@/schemas";

import {
  uploadAvatar,
  uploadResume,
  uploadTaxDocuments,
} from "../api/fileUploadApi";
import { QueryKeys } from "../queryKeys";
import { useCustomMutation } from "../queryUtils";

export function useUploadAvatarMutation() {
  const queryClient = useQueryClient();
  return useCustomMutation<ProfileResponse, Error, File>(uploadAvatar, () => {
    queryClient.invalidateQueries({ queryKey: [QueryKeys.PROFILE] });
  });
}

export function useUploadResumeMutation() {
  const queryClient = useQueryClient();
  return useCustomMutation<ProfileResponse, Error, File>(uploadResume, () => {
    queryClient.invalidateQueries({ queryKey: [QueryKeys.PROFILE] });
  });
}

export function useUploadTaxDocumentsMutation() {
  const queryClient = useQueryClient();
  return useCustomMutation<ProfileResponse, Error, File>(
    uploadTaxDocuments,
    () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PROFILE] });
    },
  );
}
